import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavigationBars from '../../components/HOC/withNavigationBars';
import actions from './duck/actions';
import { Button, colors, Breadcrumbs } from 'kangarootime-ui';
import { Link } from 'react-router-dom';
import MenuDetailPanel from './MenuDetailPanel';
import DataTable from '../../components/DataTable';
import moment from 'moment';
import editMenuActions from '../EditMenu/duck/actions';
import { MTableToolbar } from 'material-table';
import CopyMenuPopup from './CopyMenuPopup';
import DestructiveDialog from '../../components/common/DestructiveDialog';
import RaisedContainer from '../../components/RaisedContainer';
import ActionIconToolbar from '../Scheduling/IconToolbar';
import { Paper } from '@material-ui/core';

class Menus extends Component {
  constructor (props) {
    super(props);

    this.state = {
      menuIdToArchive: null,
      showArchiveMenuDialog: false
    };
  }

  get breadcrumbs () {
    return [
      { label: 'Nutrition', link: null }
    ];
  }

  componentDidMount = () => {
    this.props.getRooms();
    this.props.getMenus();
  }

  componentDidUpdate = (prevProps, prevState) => {
    // successful menu archive
    if ((prevProps.archivingMenu && !this.props.archivingMenu) && this.state.showArchiveMenuDialog) {
      this.setState({ showArchiveMenuDialog: false, menuIdToArchive: null });
    }
  }

  handeleEditAction = (event, row) => {
    const { menuId } = row;

    this.props.setMenuToEdit(row);
    this.props.history.push(`/menus/${menuId}/edit`);
  }

  showArchiveMenuDialog = (event, row) => {
    const { menuId } = row;

    this.setState({ showArchiveMenuDialog: true, menuIdToArchive: menuId });
  }

  handleArchiveMenuRequest = () => {
    const { menuIdToArchive } = this.state;

    if (menuIdToArchive === null) {
      return;
    }

    this.props.archiveMenu(menuIdToArchive);
  }

  render () {
    const { menus, fetchingMenus, archivingMenu } = this.props;
    const { showArchiveMenuDialog } = this.state;

    return (
      <NavigationBars>
        <div className='flex-columns flex-1'>
          <Breadcrumbs breadcrumbs={this.breadcrumbs} />
          <RaisedContainer>
            <div style={{ margin: 16 }}>
              <ActionIconToolbar
                icons={[{ faIcon: 'fa-print', tooltip: 'Print Current Month', onClick: () => this.props.printCurrentMonth() }]}
              />
            </div>
            <DataTable
              title='Menus'
              isLoading={fetchingMenus}
              columns={[
                { field: 'menuName', title: 'Menu Name' },
                {
                  field: 'menuDate',
                  title: 'Date',
                  type: 'datetime',
                  render: rowData => moment(rowData.menuDate).format('MMM Do, YYYY')
                },
                { field: 'menuType', title: 'Menu Type' }
              ]}
              detailPanel={rowData => (
                <div style={{ display: 'flex', flex: 1, backgroundColor: colors.athensGray2 }}>
                  <MenuDetailPanel rowData={rowData} />
                </div>
              )}
              data={menus}
              actions={[
                rowData => ({
                  icon: 'edit',
                  tooltip: 'Edit',
                  onClick: this.handeleEditAction
                }),
                rowData => ({
                  icon: 'file_copy',
                  tooltip: 'Copy',
                  onClick: event => {
                    this.copyMenuPopoverRef.getWrappedInstance().toggleDialog();
                    this.copyMenuPopoverRef.getWrappedInstance().menuToCopy = rowData;
                  }
                }),
                rowData => ({
                  icon: 'delete',
                  tooltip: 'Archive',
                  onClick: this.showArchiveMenuDialog,
                  disabled: false
                })
              ]}
              localization={{
                body: {
                  emptyDataSourceMessage: 'No menus have been created'
                }
              }}
              components={{
                Toolbar: props => (
                  <div>
                    <MTableToolbar {...props} />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                      <Link to='/menus/new' style={{ textDecoration: 'none' }}>
                        <Button
                          type='primary'
                          onClick={() => { }}
                        >
                          Create New Menu
                        </Button>
                      </Link>
                    </div>
                  </div>
                ),
                Container: props => <Paper {...props} elevation={0} />
              }}
            />
            <CopyMenuPopup ref={ref => { this.copyMenuPopoverRef = ref; }} />
            <DestructiveDialog
              isOpen={showArchiveMenuDialog}
              onClose={() => this.setState({ showArchiveMenuDialog: false, menuIdToArchive: null })}
              destructiveAction={this.handleArchiveMenuRequest}
              title='Archive Menu'
              body='Are you sure you want to archive this menu?'
              performingAction={archivingMenu}
            />
          </RaisedContainer>
        </div>
      </NavigationBars>
    );
  }
}

function mapStateToProps (state) {
  return {
    fetchingMenus: state.menus.info.fetchingMenus,
    menus: state.menus.info.menus,
    archivingMenu: state.menus.info.archivingMenu
  };
}

function mapDispatchToProps (dispatch) {
  return {
    getMenus: () => dispatch(actions.getMenusRequest()),
    getRooms: () => dispatch({ type: 'FETCH_ROOMS' }),
    setMenuToEdit: (menu) => dispatch(editMenuActions.setMenuToEdit(menu)),
    archiveMenu: (menuId) => dispatch(actions.archiveMenuRequest(menuId)),
    printCurrentMonth: () => dispatch(actions.printCurrentMonthRequest())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Menus);
